function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.121 10a8.88 8.88 0 1017.761 0A8.88 8.88 0 001.12 10zm13.511 4.633l-3.816-3.815"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.842 10a1.158 1.158 0 102.319 0A1.158 1.158 0 008.84 10h0zM10 5.754v3.089"
}));

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgTime;